import React, { createRef, useState } from "react";
import _ from "lodash";
import moment from "moment";
import { CSVLink } from "react-csv";
import Select from "components/Select";
import { useDispatch } from "react-redux";
import Button from "components/Button";
import { CSVReader } from "react-papaparse";
import GenerateInvoiceModal from "pages/zazzle-invoices/GenerateInvoiceModal";
import InvoiceTable from "pages/zazzle-invoices/InvoiceTable";
import { getZazzlePriceList, machineOrderDetails } from "actions/orders";
import { Title, TableWrapper } from "styles/pages/printify-invoices";

const buttonRef = createRef();
const productionBtnRef = createRef();

const PrintifyInvoices = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [productionCSVData, setProductionCSVData] = useState([]);
  const [country, setCountry] = useState("US");
  const [month, setMonth] = useState("");
  const handleOpenDialog = (e) => {
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  const handleOnFileLoad = (data) => {
    if (data?.length) {
      let result = [];

      for (let i = 1; i < data?.length; i++) {
        const row = data[i]?.data;

        if (row?.length > 2) {
          result.push({
            date: row[10],
            orderNumber: row[0],
            source: "Zazzle",
            qty: row[7],
            printLocations: row[12],
            data: row,
          });
        }
      }

      setData(result);
    }
  };

  const handleOnError = (err, file, inputElem, reason) => {
    alert(err);
  };

  const generateInvoice = async () => {
    const zazzlePriceList = await dispatch(getZazzlePriceList());

    const dataClone = _.clone(data);
    const orders = [];

    for (let i = 0; i < dataClone.length; i++) {
      const row = dataClone[i].data;
      let productDescription = row[4];

      if (!!productDescription) {
        const subStr = productDescription.match("Basic (.*)T-Shirt");
        if (subStr[1] == "") {
          productDescription = "Basic T-Shirt";
        } else {
          productDescription = "Basic " + subStr[1] + "T-Shirt";
        }

        const currProdQty = row[7];
        const currProdSizeArr = productDescription?.split(" ");
        const underBase = row[13];
        const printLoc = row[12];
        let size2;

        if (currProdSizeArr[currProdSizeArr.length - 1][0] == "2") {
          size2 = currProdSizeArr[currProdSizeArr.length - 1].replace("2", "x");
        } else if (currProdSizeArr[currProdSizeArr.length - 1][0] == "3") {
          size2 = currProdSizeArr[currProdSizeArr.length - 1].replace(
            "3",
            "xx"
          );
        } else if (currProdSizeArr[currProdSizeArr.length - 1][0] == "4") {
          size2 = currProdSizeArr[currProdSizeArr.length - 1].replace(
            "3",
            "xxx"
          );
        } else if (currProdSizeArr[currProdSizeArr.length - 1][0] == "5") {
          size2 = currProdSizeArr[currProdSizeArr.length - 1].replace(
            "3",
            "xxxx"
          );
        } else if (currProdSizeArr[currProdSizeArr.length - 1][0] == "6") {
          size2 = currProdSizeArr[currProdSizeArr.length - 1].replace(
            "3",
            "xxxxx"
          );
        } else {
          size2 = currProdSizeArr[currProdSizeArr.length - 1];
        }

        const currProdSize =
          currProdSizeArr[currProdSizeArr.length - 2][0] + " " + size2;
        let requireSize = currProdSize.replace(" ", "_").toLowerCase();

        if (requireSize[requireSize.length - 1] == "x") {
          requireSize = requireSize + "l";
        }

        let blankProdPrice;
        let packingPrice;
        let printPrice;

        if (
          productDescription == "Basic T-Shirt" ||
          productDescription == "Basic Dark T-Shirt"
        ) {
          if (
            requireSize == "a_s" ||
            requireSize == "a_m" ||
            requireSize == "a_l" ||
            requireSize == "a_xl"
          ) {
            blankProdPrice = 2.26;
          } else if (requireSize == "a_xxl") {
            blankProdPrice = 4.11;
          } else if (
            requireSize == "a_xxxl" ||
            requireSize == "a_xxxxl" ||
            requireSize == "a_xxxxxl" ||
            requireSize == "a_xxxxxxl"
          ) {
            blankProdPrice = 5.18;
          } else {
            blankProdPrice = 2.26;
          }
          if (underBase == "True") {
            if (printLoc == "1") {
              printPrice = 5.55;
            } else if (printLoc == "2") {
              printPrice = 9.06;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 5.55;
            }
            packingPrice = 0.26;
          } else if (underBase == "False") {
            if (printLoc == "1") {
              printPrice = 3.35;
            } else if (printLoc == "2") {
              printPrice = 4.7;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 3.35;
            }
            packingPrice = 0.26;
          } else {
            printPrice = 0;
            packingPrice = 0.26;
          }
        } else if (productDescription == "Basic 3/4 Sleeve Raglan T-Shirt") {
          if (
            requireSize == "a_s" ||
            requireSize == "a_m" ||
            requireSize == "a_l" ||
            requireSize == "a_xl"
          ) {
            blankProdPrice = 4.24;
          } else if (requireSize == "a_xxl") {
            blankProdPrice = 5.88;
          } else if (
            requireSize == "a_xxxl" ||
            requireSize == "a_xxxxl" ||
            requireSize == "a_xxxxxl" ||
            requireSize == "a_xxxxxxl"
          ) {
            blankProdPrice = 6.71;
          } else {
            blankProdPrice = 4.24;
          }
          if (underBase == "True") {
            if (printLoc == "1") {
              printPrice = 3.35;
            } else if (printLoc == "2") {
              printPrice = 4.7;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 3.35;
            }
            packingPrice = 0.26;
          } else if (underBase == "False") {
            if (printLoc == "1") {
              printPrice = 3.35;
            } else if (printLoc == "2") {
              printPrice = 4.7;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 3.35;
            }
            packingPrice = 0.26;
          } else {
            printPrice = 0;
            packingPrice = 0.26;
          }
        } else if (
          productDescription == "Basic Ladies T-Shirt" ||
          productDescription == "Womens Basic T-Shirt"
        ) {
          if (
            requireSize == "a_s" ||
            requireSize == "a_m" ||
            requireSize == "a_l" ||
            requireSize == "a_xl"
          ) {
            blankProdPrice = 2.4;
          } else if (requireSize == "a_xxl") {
            blankProdPrice = 4.04;
          } else if (
            requireSize == "a_xxxl" ||
            requireSize == "a_xxxxl" ||
            requireSize == "a_xxxxxl" ||
            requireSize == "a_xxxxxxl"
          ) {
            blankProdPrice = 4.76;
          } else {
            blankProdPrice = 2.4;
          }
          if (underBase == "True") {
            if (printLoc == "1") {
              printPrice = 5.55;
            } else if (printLoc == "2") {
              printPrice = 9.06;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 5.55;
            }
            packingPrice = 0.26;
          } else if (underBase == "False") {
            if (printLoc == "1") {
              printPrice = 3.35;
            } else if (printLoc == "2") {
              printPrice = 4.7;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 3.35;
            }
            packingPrice = 0.26;
          } else {
            printPrice = 0;
            packingPrice = 0.26;
          }
        } else {
          if (
            requireSize == "a_s" ||
            requireSize == "a_m" ||
            requireSize == "a_l" ||
            requireSize == "a_xl"
          ) {
            blankProdPrice = 2.26;
          } else if (requireSize == "a_xxl") {
            blankProdPrice = 4.11;
          } else if (
            requireSize == "a_xxxl" ||
            requireSize == "a_xxxxl" ||
            requireSize == "a_xxxxxl" ||
            requireSize == "a_xxxxxxl"
          ) {
            blankProdPrice = 5.18;
          } else {
            blankProdPrice = 2.26;
          }
          if (underBase == "True") {
            if (printLoc == "1") {
              printPrice = 5.55;
            } else if (printLoc == "2") {
              printPrice = 9.06;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 5.55;
            }
            packingPrice = 0.26;
          } else if (underBase == "False") {
            if (printLoc == "1") {
              printPrice = 3.35;
            } else if (printLoc == "2") {
              printPrice = 4.7;
            } else if (printLoc == "0") {
              printPrice = 0;
            } else {
              printPrice = 3.35;
            }
            packingPrice = 0.26;
          } else {
            printPrice = 0;
            packingPrice = 0.26;
          }
        }

        const unitPrice = blankProdPrice + printPrice + packingPrice;
        const totalPrice = Number(currProdQty) * unitPrice;

        const trackingNumber = await dispatch(
          machineOrderDetails({
            PrintProvider: "US",
            orderPo: `O${row[0]}`,
            source: "Zazzle",
          })
        );

        let trackingNumberValue =
          trackingNumber?.string?._text?.split("<trackingNumber>");

        if (trackingNumberValue?.length) {
          trackingNumberValue =
            trackingNumberValue[1]?.split("</trackingNumber>")[0];
        }

        const alreadyExist = !!orders?.find((o) => o === row[0]);

        dataClone[i].packagingPrice = alreadyExist
          ? "0"
          : packingPrice.toFixed(2);

        dataClone[i].blankCost = blankProdPrice.toFixed(2);
        dataClone[i].printCost = printPrice.toFixed(2);
        dataClone[i].totalAmount = totalPrice.toFixed(2);
        dataClone[i].trackingNumber = `'${trackingNumberValue}`;

        if (!alreadyExist) {
          orders.push(row[0]);
        }
      }
    }

    let rows = [
      [
        "Order ID",
        "Line Item ID",
        "Item Type",
        "SKU",
        "Product/ Description",
        "Size",
        "Color",
        "QTY",
        "Blank Amount",
        "Print Amount",
        "Packaging Amount",
        "Total Amount",
        "Ship Date",
        "Tracking Number",
        "Print Locations",
        "White Underbase",
        "Order Notes",
        "Status",
      ],
    ];

    for (let i = 0; i < dataClone.length; i++) {
      const row = dataClone[i].data;
      rows.push([
        row[0],
        row[1],
        row[2],
        row[3],
        row[4],
        row[5],
        row[6],
        row[7],
        dataClone[i].blankCost,
        dataClone[i].printCost,
        dataClone[i].packagingPrice,
        dataClone[i].totalAmount,
        row[10],
        dataClone[i].trackingNumber,
        row[12],
        row[13],
        row[14],
        row[15],
      ]);
    }

    setData(() => dataClone);

    setProductionCSVData(rows);

    setTimeout(() => {
      productionBtnRef.current?.link?.click();
    }, 0);
  };

  return (
    <React.Fragment>
      <Title>
        <div>Zazzle Invoices</div>
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: 20, width: 116 }}>
            <Select
              label="Select Country"
              options={["US"]}
              value={country}
              onChange={(v) => setCountry(v)}
            />
          </div>

          <div style={{ marginRight: 20, width: 150 }}>
            <Select
              label="Select Month"
              options={[
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ]}
              value={month}
              onChange={(v) => setMonth(v)}
            />
          </div>
          {month && (
            <CSVReader
              ref={buttonRef}
              onFileLoad={handleOnFileLoad}
              onError={handleOnError}
              noClick
              noDrag
              noProgressBar
            >
              {({ file }) => (
                <aside
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <button
                    type="button"
                    onClick={handleOpenDialog}
                    style={{
                      width: 100,
                      cursor: "pointer",
                      background: "#000",
                      color: "#fff",
                      border: "none",
                      fontWeight: "bold",
                      minHeight: 35,
                    }}
                  >
                    Upload file
                  </button>
                  {file && (
                    <div
                      style={{
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: "#000",
                        textAlign: "center",
                        minHeight: 35,
                        lineHeight: 2.5,
                        width: 200,
                        fontSize: 12,
                      }}
                    >
                      {file && file.name}
                    </div>
                  )}
                </aside>
              )}
            </CSVReader>
          )}

          {data && (
            <>
              <Button
                title="Fill Amount"
                onClick={generateInvoice}
                containerStyle={{
                  marginLeft: 10,
                  padding: "0px 10px",
                  height: "35px",
                  background: "black",
                  color: "white",
                }}
              />
            </>
          )}
          <CSVLink
            style={{ display: "none" }}
            ref={productionBtnRef}
            filename={`Zazzle_Invoice_${month}_${moment().format("YYYY")}.csv`}
            data={productionCSVData}
          >
            Download me
          </CSVLink>
        </div>
      </Title>
      {data && (
        <TableWrapper>
          <InvoiceTable data={data} />
        </TableWrapper>
      )}
    </React.Fragment>
  );
};

export default PrintifyInvoices;
